export default function auth({ next, store }) {
    if (!process.server && !store.getters["auth/loggedIn"]) {
      return next({
        name: "Login",
      });
    } 
    next();
}
  